import { render, staticRenderFns } from "./ArtworkGridDetailsEllipsis.vue?vue&type=template&id=75a6017d"
import script from "./ArtworkGridDetailsEllipsis.vue?vue&type=script&lang=js"
export * from "./ArtworkGridDetailsEllipsis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports